import { Spin } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'

export const InitialLoadingBlock: FunctionComponent = () => {
  return (
    <Spin>
      <Wrapper />
    </Spin>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 300px;
`
